/* eslint-disable react/react-in-jsx-scope */
/* -------------------------------------------------------------------------- */
/*                                Configuration                                 */
/* -------------------------------------------------------------------------- */
import React from 'react';
import ScopeFilterOperators from 'ui/components/DataGrid/Filters/ScopeFilter/ScopeFilter';
import ActiveFilterOperators from 'ui/components/DataGrid/Filters/ActiveFilter/ActiveFilter';
import TypeFilterOperators from 'ui/components/DataGrid/Filters/TypeFilter/TypeFilter';
import LanguageFilterOperators from 'ui/components/DataGrid/Filters/LanguageFilter/LanguageFilter';
import DateFilterOperators from 'ui/components/DataGrid/Filters/DateFilter/DateFilter';

/**
Table schema configuration for the module
@type {TableSchemaBase}
*/

const tableSchemaBase = [
  { field: 'user', flex: 1, headerName: 'name', minWidth: 250, fontSize: '2px', type: 'user', resizable: true },
  {
    field: 'roles',
    headerName: 'Roles',
    type: 'text',
    minWidth: 130,
    resizable: true,
    flex: 1,
  },
  {
    field: 'email',
    headerName: 'email',
    type: 'text',
    minWidth: 130,
    resizable: true,
    flex: 1,
  },
  {
    field: 'scopeName',
    headerName: 'scope',
    type: 'text',
    minWidth: 130,
    filterOperators: ScopeFilterOperators,
    resizable: true,
    flex: 1,
  },
  {
    field: 'createdAt',
    headerName: 'creation_date',
    resizable: true,
    minWidth: 180,
    type: 'text',
    flex: 1,
    filterOperators: DateFilterOperators,
  },
  {
    field: 'actions',
    headerName: 'actions',
    sortable: false,
    minWidth: 120,
    filter: false,
    filterable: false,
    valueGetter: (params) => `${params.row.firstName || ''} ${params.row.lastName || ''}`,
    type: 'actionsAdmins',
    headerAlign: 'center',
    align: 'center',
    flex: 1,
    resizable: true,
    disableColumnMenu: true,
  },
];

export { tableSchemaBase };
